import { FC } from "react";
import { Badge, Tag, Typography, Switch } from 'antd';
import './styles.scss';
import { useTranslation } from "react-i18next";
const { Text } = Typography;




export const StatusData: React.FC<{ status: number }> = ({ status }): JSX.Element => status ? <span className="status_data status_data_active">active</span> : <span className="status_data status_data_inactive">inactive</span>

const CustomBadgeComponent: FC<{ text: string, color: string, isText: any }> = ({ text, color, isText }): JSX.Element => {
    if (isText === "text") {
        return (
            <Text type="success">{text}</Text>
        )
    }
    else {
        return (
            <Badge count={text} style={{ backgroundColor: color }}></Badge>
        )
    }
}

const StatusChecker: FC<{ status: number | undefined | null, isText: 'text' | 'badge' }> = ({ status, isText }): JSX.Element => {
    const { i18n, t } = useTranslation();


    if (isText === "badge") {
        switch (Number(status)) {
            case 10:
                return <Switch size="small" disabled={true} checkedChildren={t("Active")} defaultChecked={true}/>
            case 5:
                return <Switch size="small" disabled={true} unCheckedChildren={t('InActive')} defaultChecked={false}/>
            case 0:
                return <Switch size="small" disabled={true} className='pending' checkedChildren='Pending...' defaultChecked={true}/>
            default:
                return <CustomBadgeComponent text="error" color="#fa541c" isText={isText} />
        }
    } else {
        switch (Number(status)) {
            case 10:
                return <CustomBadgeComponent text="Active" color="success" isText={isText} />
            case 5:
                return <CustomBadgeComponent text="Pending" color="warning" isText={isText} />
            case 0:
                return <CustomBadgeComponent text="Banned" color="danger" isText={isText} />
            default:
                return <CustomBadgeComponent text="error" color="danger" isText={isText} />
        }
    }

}




export default StatusChecker;